var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{staticClass:"row banner-button"},[_c('q-card-main',{on:{"click":function($event){$event.preventDefault();_vm.console.log('click')}}},[_c('q-item',{attrs:{"link":"","to":_vm.to}},[(_vm.img.url!=null)?_c('img',{attrs:{"src":_vm.img.url}}):_c('p',[_vm._v(_vm._s(_vm.alt))])])],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-605a4474","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/BannerButton.vue
// module id = yuY0
// module chunks = 76